import PropTypes from 'prop-types'
import { Card, H4, P1, Icon, useWindowSize } from '@moneymade/moneymade-ui'
import { useTransition, animated } from 'react-spring'
import { useState, useEffect } from 'react'

import styles from './Considerations.module.scss'

const Considerations = ({ title, drawbacks, reasonsInvest }) => {
  const { screenWidth } = useWindowSize()

  const [showMore, setShowMore] = useState(true)

  useEffect(() => {
    if (screenWidth > 601 && !showMore) {
      setShowMore(true)
    } else if (screenWidth !== 0 && showMore) {
      setShowMore(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenWidth])

  const transition = useTransition(showMore, {
    from: { transform: 'translateY(-20px)', opacity: 0 },
    enter: { transform: 'translateY(0)', opacity: 1 },
    leave: { transform: 'translateY(-20px)', opacity: 0 },
    config: { duration: 200 }
  })

  return (
    <Card className={styles.Considerations}>
      <div className={`${styles.Header} ${showMore ? styles.isOpen : ''}`}>
        {title && (
          <H4 weight="semibold " className={styles.Title}>
            {title}
          </H4>
        )}
        <button type="button" className={styles.Heading} onClick={() => setShowMore(prev => !prev)}>
          {showMore ? <Icon icon="icon-point-up" size={18} /> : <Icon icon="icon-point-down" size={18} />}
        </button>
      </div>
      {transition(
        (springStyles, item) =>
          item && (
            <animated.div style={springStyles} className={styles.Content}>
              <ul className={styles.LeftSide}>
                <P1 weight="normal" className={styles.Title}>
                  Reasons to Invest
                </P1>

                {reasonsInvest.map(({ point }, index) => (
                  <li key={`li-${index}`}>
                    <P1 weight="light">{point}</P1>
                  </li>
                ))}
              </ul>

              <ul className={styles.RightSide}>
                <P1 weight="normal" className={styles.Title}>
                  Drawbacks
                </P1>

                {drawbacks.map(({ point }, index) => (
                  <li key={`li-${index}`}>
                    <P1 weight="light">{point}</P1>
                  </li>
                ))}
              </ul>
            </animated.div>
          )
      )}
    </Card>
  )
}
Considerations.propTypes = {
  title: PropTypes.string,
  drawbacks: PropTypes.arrayOf(PropTypes.object),
  reasonsInvest: PropTypes.arrayOf(PropTypes.object)
}

Considerations.defaultProps = {
  title: '',
  drawbacks: [],
  reasonsInvest: []
}

export default Considerations
